var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76028 0.708991C2.15071 0.317588 2.78464 0.317243 3.17549 0.70822L9.79278 7.32764C10.1833 7.71832 10.8167 7.71832 11.2072 7.32764L17.8245 0.708219C18.2154 0.317242 18.8493 0.317589 19.2397 0.708992L20.2955 1.76746C20.6849 2.15778 20.6849 2.78958 20.2955 3.17991L11.208 12.2902C10.8173 12.6819 10.1827 12.6819 9.79201 12.2902L0.704456 3.17991C0.315111 2.78958 0.315111 2.15778 0.704456 1.76746L1.76028 0.708991Z",
    fill: "#B0BEC5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.324c4fa8.svg";
export { ForwardRef as ReactComponent };